import { Boundaries } from "@planzone/core";
import { State } from "./types";
import { isInRange } from "./utils";

function handlecreateUnavailabilitySuccess(
  state: State,
  { unavailability }: Boundaries["createUnavailability"]["success"],
): State {
  return state.map((req) => ({
    ...req,
    calendar: {
      ...req.calendar,
      unavailabilities: isInRange(req.filter, {
        startDate: unavailability.startDate,
        endDate: unavailability.endDate || unavailability.startDate,
      })
        ? [...req.calendar.unavailabilities, unavailability]
        : req.calendar.unavailabilities,
    },
  }));
}

export { handlecreateUnavailabilitySuccess };
